function BlogExcerptBlock({ post }) {
    return (
        <div
            className="mt-2 text-blog-gray font-light"
            dangerouslySetInnerHTML={{
                __html: post.excerpt.rendered,
            }}></div>
    )
}

export default BlogExcerptBlock
